<template>
<div id="left-panel-nav" :type="$store.getters.getSmallScreenStatus ? 'modal': 'dismissible'" class="mcc-drawer mcc-drawer--start mcc-drawer-w-fixed no-print" :class="!theme.menuOnTop ? 'mcc-drawer--open ' : ''" ref="leftsideDrawer" :key="leftContainerKey">

    <div class="mcc-drawer__content">
        <nav class="mcc-menu">
            <div class="mcc-menu__title">

                <img :src="(theme.logo != null && theme.logo != '') ? theme.logo : 'https://cdn.svc.oneadvanced.com/mosaic/2.0.0/img/logo.svg'" alt="Logo" style="height: 40px; width: 40px;" /><span class="h6 productName" :title="theme.productName">{{theme.productName}}</span>
            </div>
            <div class="mfc-input-wrapper mu-mx-04">
                <div class="mfc-input-group mfc-input-group--leading-icon">
                    <mcc-icon class="mfc-input-group__icon mu-pt-03" name="search" id="list-group-icon" aria-hidden="true"></mcc-icon>
                    <input id="menuFilter" name="list-group-filter" type="text" placeholder="Search..." @input="filterMenuItems($event.target.value)">
                </div>
            </div>
           

            <details class="mcc-collapse" v-if="checkRole('RoleUser') || checkRole('AdvRoleUser')">
                <summary>
                    <div class="mcc-menu__button" @click="viewProcesses()">
                        <mcc-icon name="home" aria-hidden="true"></mcc-icon><span class="mcc-button__label" >View
                            processes</span>
                    </div>
                </summary>
               
            </details>
            <details class="mcc-collapse" v-if="checkRole('RoleUser') || checkRole('AdvRoleUser')"> 
                <summary>
                    <div class="mcc-menu__button">
                        <mcc-icon name="process" aria-hidden="true"></mcc-icon><span class="mcc-button__label">My
                            processes</span>
                    </div>
                    <mcc-icon class="mcc-button__dropdown-caret" name="expand_arrow" aria-hidden="true"></mcc-icon>

                </summary>
                <div class="mcc-collapse-body mu-ml-07 mu-mt-03">
                    <NavigationButton classname="mcc-menu__button" id="startedByMeNav" label="Started by me" :to="CONTEXT_PATH + '/processes/startedbyme'" />
                    <NavigationButton classname="mcc-menu__button" id="allInvolvedNav" label="All involved" :to="CONTEXT_PATH + '/processes/involvingme'" />
                    <NavigationButton classname="mcc-menu__button" id="draftsProcessNav" label="Drafts" :to="CONTEXT_PATH + '/processes/drafts'" />
                </div>
            </details>

            <details class="mcc-collapse" id="myTasks" v-if="checkRole('RoleUser') || checkRole('AdvRoleUser')">
                <summary>
                    <div class="mcc-menu__button" id="myTasksNav">
                        <mcc-icon name="tasks" aria-hidden="true"></mcc-icon><span class="mcc-button__label">My
                            tasks</span>
                    </div>
                    <mcc-icon class="mcc-button__dropdown-caret" name="expand_arrow" aria-hidden="true"></mcc-icon>

                </summary>
                <div class="mcc-collapse-body mu-ml-07 mu-mt-03">
                    <NavigationButton classname="mcc-menu__button" id="assignedTaskNav" label="Assigned" :to="CONTEXT_PATH + '/tasks/assigned'" />
                    <NavigationButton classname="mcc-menu__button" id="unclaimedTaskNav" label="Unclaimed" :to="CONTEXT_PATH + '/tasks/unclaimed'" />
                    <NavigationButton classname="mcc-menu__button" id="allInvolvedTaskNav" label="All involved" :to="CONTEXT_PATH + '/tasks/involvingme'" />
                    <NavigationButton classname="mcc-menu__button" id="draftsTaskNav" label="Drafts" :to="CONTEXT_PATH + '/tasks/drafts'" />
                </div>
            </details>

            <details class="mcc-collapse" id="processEngineNav" v-if="checkRole('RoleProcessAdmin')">
                <summary>
                    <div class="mcc-menu__button" id="processEngineNav">
                        <mcc-icon name="gears" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Process
                            engine</span>
                    </div>
                    <mcc-icon class="mcc-button__dropdown-caret" name="expand_arrow" aria-hidden="true"></mcc-icon>

                </summary>
                <div class="mcc-collapse-body mu-ml-06 mu-mt-03">
                    <NavigationButton classname="mcc-menu__button" id="deploymentNav" label="Deployments" :to="CONTEXT_PATH + '/processengine/deployment'" icon="deployment" />
                    <NavigationButton classname="mcc-menu__button" id="definitionNav" label="Definitions" :to="CONTEXT_PATH + '/processengine/processdefinitions'" icon="brief" />

                    <NavigationButton classname="mcc-menu__button" id="instancesNav" label="Instances" :to="CONTEXT_PATH + '/processengine/processes'" icon="prototype" v-if="!processCustomViews.length > 0" />
                    <div v-if="processCustomViews.length > 0">
                        <details class="mcc-menu__collapse" >
                            <summary>
                                <div class="mcc-menu__button">
                                    <mcc-icon name="prototype" icon-set="fluency-outline" aria-hidden="true"></mcc-icon>
                                    <span class="mcc-button__label">Instances</span>
                                    <mcc-icon class="mcc-menu-arrowbtn" name="expand_arrow" aria-hidden="true"></mcc-icon>
                                </div>
                            </summary>
                            <div class="mcc-collapse-body mu-ml-04 mu-mt-03">
                                <NavigationButton classname="mcc-menu__button" id="viewInstancesNav" label="View instances" :to="CONTEXT_PATH + '/processengine/processes'" icon="prototype">
                                </NavigationButton>
                                <NavigationButton classname="mcc-menu__button" :id="'viewCustomProcessNav-' + key" v-for="(view, key) in processCustomViews" :key="key" :to="CONTEXT_PATH + '/processengine/processes/customview/' + view.id" :label="view.aliasName" icon="deployment"></NavigationButton>
                            </div>
                        </details>
                        
                    </div>
                
                    <NavigationButton classname="mcc-menu__button" id="processEngineTaskNav" label="Tasks" :to="CONTEXT_PATH + '/processengine/tasks'" icon="tasks" v-if="!taskCustomViews.length > 0" />
                   
                 <div  v-if="taskCustomViews.length > 0">
                    <details class="mcc-menu__collapse">
                            <summary>
                                <div class="mcc-menu__button">
                                    <mcc-icon name="prototype" icon-set="fluency-outline" aria-hidden="true"></mcc-icon>
                                    <span class="mcc-button__label">Tasks</span>
                                    <mcc-icon class="mcc-menu-arrowBtn" name="expand_arrow" aria-hidden="true"></mcc-icon>
                                </div>
                            </summary>
                            <div class="mcc-collapse-body mu-ml-04 mu-mt-03">
                        <NavigationButton classname="mcc-menu__button" id="viewTasksNav" label="View tasks" :to="CONTEXT_PATH + '/processengine/tasks'" icon="tasks"></NavigationButton>
                        <NavigationButton v-for="(view, key) in taskCustomViews" :key="key" classname="mcc-menu__button" :id="'viewCustomTaskNav-' + key" :to="CONTEXT_PATH + '/processengine/tasks/customview/' + view.id" :label="view.aliasName" icon="deployment">
                        </NavigationButton>
                   
                        </div>
                    </details>

                    
</div>
                    <NavigationButton classname="mcc-menu__button" id="jobsNav" label="Jobs" :to="CONTEXT_PATH + '/processengine/jobs'" icon="job" />
                    <NavigationButton classname="mcc-menu__button" id="processErrorsNav" label="Process errors" :to="CONTEXT_PATH + '/processengine/processFailure'" icon="error" />
                </div>
            </details>

            <details class="mcc-collapse" v-if="checkRole('RoleDesign')">
                <summary>
                    <div class="mcc-menu__button" id="designNav">
                        <mcc-icon name="design" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Design</span>
                    </div>
                    <mcc-icon class="mcc-button__dropdown-caret" name="expand_arrow" aria-hidden="true"></mcc-icon>

                </summary>
                <div class="mcc-collapse-body mu-ml-06 mu-mt-03">
                    <NavigationButton classname="mcc-menu__button" id="applicationsNav" label="Applications" :to="CONTEXT_PATH + '/design/applications'" icon="mesh" />
                    <NavigationButton classname="mcc-menu__button" id="categoriesNav" label="Categories" :to="CONTEXT_PATH + '/design/categories'" icon="categorize" />
                    <NavigationButton classname="mcc-menu__button" id="globalPropertiesNav" label="Global properties" :to="CONTEXT_PATH + '/design/globalProcessProperties'" icon="property_script" />
                    <NavigationButton classname="mcc-menu__button" id="appProcessesNav" label="Processes" :to="CONTEXT_PATH + '/design/applications/appprocesses'" icon="process" />
                    <NavigationButton classname="mcc-menu__button" id="appFormsNav" label="Forms" :to="CONTEXT_PATH + '/design/forms'" icon="form" />
                    <NavigationButton classname="mcc-menu__button" id="formTemplatesNav" label="Form templates" :to="CONTEXT_PATH + '/design/formTemplates'" icon="form" />
                    <NavigationButton classname="mcc-menu__button" id="emailTemplatesNav" label="Email templates" :to="CONTEXT_PATH + '/design/emailTemplates'" icon="gmail" />
                    <NavigationButton classname="mcc-menu__button" id="customDataListNav" label="Custom data list" :to="CONTEXT_PATH + '/design/customdatalist'" icon="list" />
                </div>
            </details>

            <details class="mcc-collapse" v-if="checkRole('RoleIntegration')" id="integrateNav">
                <summary>
                    <div class="mcc-menu__button">
                        <mcc-icon name="linking" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Integrate</span>
                    </div>
                    <mcc-icon class="mcc-button__dropdown-caret" name="expand_arrow" aria-hidden="true"></mcc-icon>

                </summary>
                <div class="mcc-collapse-body mu-ml-06 mu-mt-03">
                    <NavigationButton classname="mcc-menu__button" id="externalSystemsNav" label="External systems" :to="CONTEXT_PATH + '/integrate/externalsystems'" icon="external_link" />
                </div>
            </details>

            <details class="mcc-collapse" v-if="checkRole('RoleUserAdmin')" id="userAndGroupsNav">
                <summary>
                    <div class="mcc-menu__button">
                        <mcc-icon name="user_groups" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Users &
                            groups</span>
                    </div>
                    <mcc-icon class="mcc-button__dropdown-caret" name="expand_arrow" aria-hidden="true"></mcc-icon>

                </summary>
                <div class="mcc-collapse-body mu-ml-06 mu-mt-03">
                    <NavigationButton classname="mcc-menu__button" id="usersNav" label="Users" :to="CONTEXT_PATH + '/usersgroups/users'" icon="user" />
                    <NavigationButton classname="mcc-menu__button" id="userPropertiesNav" label="User properties" :to="CONTEXT_PATH + '/usersgroups/userProperties'" icon="content" />
                    <NavigationButton classname="mcc-menu__button" id="groupsNav" label="Groups" :to="CONTEXT_PATH + '/usersgroups/groups'" icon="conference" />
                    <NavigationButton classname="mcc-menu__button" id="hierarchiesNav" label="Hierarchies" :to="CONTEXT_PATH + '/usersgroups/hierarchies'" icon="tree_structure" />
                    <NavigationButton classname="mcc-menu__button" v-if="checkRole('RoleAdmin')" id="rolesNav" label="Roles" :to="CONTEXT_PATH + '/usersgroups/roles'" icon="add_user_male" />
                </div>
            </details>

            <details class="mcc-collapse" v-if="checkRole('RoleAdmin')" id="adminNav">
                <summary>
                    <div class="mcc-menu__button">
                        <mcc-icon name="settings" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Administration</span>
                    </div>
                    <mcc-icon class="mcc-button__dropdown-caret" name="expand_arrow" aria-hidden="true"></mcc-icon>

                </summary>
                <div class="mcc-collapse-body mu-ml-06 mu-mt-03">
                    <NavigationButton classname="mcc-menu__button" id="dashboardNav" label="Dashboard" :to="CONTEXT_PATH + '/admin/dashboard'" icon="dashboard" />
                    <NavigationButton classname="mcc-menu__button" id="importExportNav" label="Import/Export" :to="CONTEXT_PATH + '/admin/importexport'" icon="swap" />
                    <NavigationButton classname="mcc-menu__button" id="systemTemplateNav" label="System templates" :to="CONTEXT_PATH + '/admin/systemTemplates'" icon="template" />
                    <NavigationButton classname="mcc-menu__button" id="auditHistoryNav" label="Audit history" :to="CONTEXT_PATH + '/admin/audit'" icon="past" />
                    <NavigationButton classname="mcc-menu__button" id="settingsNav" label="Settings" :to="CONTEXT_PATH + '/admin/settings'" icon="settings" />
                    <NavigationButton classname="mcc-menu__button" id="themesNav" label="Themes" :to="CONTEXT_PATH + '/admin/themes'" icon="calligraphy_brush" />
                    <NavigationButton classname="mcc-menu__button" id="licenceManagementNav" label="Licence management" :to="CONTEXT_PATH + '/admin/licenceManagement'" icon="software_license" />
                    <button class="mcc-menu__button" v-if="leftContainerProperty.monitorEnabled == 'true'" id="monitorNav" @click="getAbsoluteUrl(leftContainerProperty.monitorURL)">
                        <mcc-icon name="clock" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Monitor
                            application</span>
                    </button>

                </div>
            </details>

        </nav>

    </div>

</div>
</template>

<script>
import NavigationButton from './NavigationButton.vue'
import Drilldown from './Drilldown.vue';
import {
    EventBus
} from "@/services/event-bus";
export default {
    props: ['leftContainerProperty'],
    components: {
        NavigationButton,
        Drilldown
    },
    data() {
        return {
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            customViews: {},
            taskCustomViews: {},
            processCustomViews: {},
            theme: {},
            leftContainerKey: 0,
        }
    },
    mounted() {
        let self = this;
        this.customViews = this.$store.getters.getCustomViews;
        this.taskCustomViews = this.customViews.taskTypeList;
        this.processCustomViews = this.customViews.processTypeList;

        this.theme = this.$store.getters.getThemeData;

        EventBus.$on("updateCustomViewDrilldown", result => {
            self.taskCustomViews = [];
            setTimeout(() => {
                self.taskCustomViews = result;
            }, 1000);
        });

        EventBus.$on("updateCustomViewProcessDrilldown", result => {
            self.processCustomViews = [];
            setTimeout(() => {
                self.processCustomViews = result;
            }, 1000);
        });
        EventBus.$on("updateTheme", result => {
            self.theme = result;
            self.leftContainerKey += 1;
        });
        EventBus.$on("ToggleDrawer", this.toggleDrawer);

        window.addEventListener('resize', this.checkIsSmallScreen);
        self.checkIsSmallScreen()
        if (self.$store.getters.getSmallScreenStatus) {
            self.$refs.leftsideDrawer.classList.remove("mcc-drawer--open")
            this.$store.commit('setDrawerStatus', false);
        }

    },
    methods: {
        viewProcesses() {
            this.$router.push(
                this.CONTEXT_PATH +
                "/category/view/Home"
            );
        },
        checkIsSmallScreen() {
            let isSmall = window.innerWidth <= 1152;
            this.$store.commit('setSmallScreenStatus', isSmall);

        },
        filterMenuItems(filterText) {
  const menu = document.querySelector('.mcc-menu');
  const menuItems = menu.querySelectorAll('details');
  const drilldownItems = menu.querySelectorAll('.mcc-drilldown');
  const filterSearchText = filterText.toLowerCase();

  if (filterSearchText.trim() === "") {
    menuItems.forEach(item => {
      item.style.display = '';
      $(item).removeAttr('open');
      item.querySelectorAll('button').forEach(button => {
        button.style.display = '';
      });
    });
    drilldownItems.forEach(item => {
      item.style.display = '';
      item.querySelectorAll('button').forEach(button => {
        button.style.display = '';
      });
    });
    return;
  }

  menuItems.forEach(item => {
    const summary = item.querySelector('summary');
    const summaryText = summary?.textContent.toLowerCase() || '';
    const childButtons = item.querySelectorAll('button');

    let parentMatches = summaryText.includes(filterSearchText);
    let anyChildMatches = false;

    childButtons.forEach(button => {
      const buttonText = button.textContent.toLowerCase();
      if (buttonText.includes(filterSearchText)) {
        button.style.display = '';
        anyChildMatches = true;
      } else {
        button.style.display = 'none';
      }
    });

    if (parentMatches) {
      item.style.display = '';
      $(item).removeAttr('open');
      childButtons.forEach(button => {
        button.style.display = '';
      });
    } else if (anyChildMatches) {
      item.style.display = '';
      $(item).attr('open', true);
    } else {
      item.style.display = 'none';
      $(item).removeAttr('open');
    }
  });

  drilldownItems.forEach(drilldownItem => {
    const detailText = drilldownItem.textContent.toLowerCase();
    const drilldownButtons = drilldownItem.querySelectorAll('button');
    let anyChildMatches = false;

    drilldownButtons.forEach(button => {
      const buttonText = button.textContent.toLowerCase();
      if (buttonText.includes(filterSearchText)) {
        button.style.display = '';
        anyChildMatches = true;
      } else {
        button.style.display = '';
      }
    });

    if (anyChildMatches) {
      drilldownItem.style.display = '';
      drilldownButtons.forEach(button => {
        button.style.display = '';
      });
    } else {
      drilldownItem.style.display = 'none';
    }
  });
},

        toggleDrawer() {
            let self = this;
            if (self.$refs.leftsideDrawer.classList.contains("mcc-drawer--open")) {
                self.$refs.leftsideDrawer.classList.remove("mcc-drawer--open")
                this.$store.commit('setDrawerStatus', false);

            } else {
                self.$refs.leftsideDrawer.classList.add("mcc-drawer--open")
                this.$store.commit('setDrawerStatus', true);

            }

        },
        handleClick() {
            this.$router.push(this.CONTEXT_PATH + "/category/view/Home").catch(err => {
                if (err.name !== 'NavigationDuplicated' &&
                    !err.message.includes('Avoided redundant navigation to current location')) {
                    logError(err);
                }
            });
            EventBus.$emit("openRightDrawer");
        },
        getAbsoluteUrl(urlToAppend) {
            if (urlToAppend.indexOf('http')) {
                urlToAppend = 'http://' + urlToAppend;
            }

            window.open(
                urlToAppend,
                "_blank");
        },
        checkRole(roleName) {
            var hasRole = false;
            switch (roleName) {
                case "RoleAdmin":
                    hasRole = this.$store.getters.getRoleAdmin;
                    break;
                case "RoleDesign":
                    hasRole = this.$store.getters.getRoleDesign;
                    break;
                case "RoleIntegration":
                    hasRole = this.$store.getters.getRoleIntegration;
                    break;
                case "RoleProcessAdmin":
                    hasRole = this.$store.getters.getRoleProcessAdmin;
                    break;
                case "RoleUser":
                    hasRole = this.$store.getters.getRoleUser;
                    break;
                case "RoleUserAdmin":
                    hasRole = this.$store.getters.getRoleUserAdmin;
                    break;
                case "RoleFullAPI":
                    hasRole = this.$store.getters.getRoleFullAPI;
                    break;
                case "AdvRoleAdmin":
                    hasRole = this.$store.getters.getAdvRoleAdmin;
                    break;
                case "AdvRoleDesign":
                    hasRole = this.$store.getters.getAdvRoleDesign;
                    break;
                case "AdvRoleIntegration":
                    hasRole = this.$store.getters.getAdvRoleIntegration;
                    break;
                case "AdvRoleUser":
                    hasRole = this.$store.getters.getAdvRoleUser;
                    break;
                case "AdvRoleUserAdmin":
                    hasRole = this.$store.getters.getAdvRoleUserAdmin;
                default:
                    break;
            }
            return hasRole;
        }
    }
}
</script>

<style scoped>
.productName {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
</style>
